"use client";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";

let posthogInitialized = false;

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST;

export function PostHogClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    if (!POSTHOG_KEY) return;
    if (posthogInitialized) return;

    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST || "https://app.posthog.com",
      capture_pageview: false,
      loaded: (client) => {
        if (process.env.NODE_ENV === "development") {
          client.debug();
        }
      },
    });

    posthogInitialized = true;
  }, []);

  if (!POSTHOG_KEY) return children;

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
